/** US English and Spanish Standard voices supported by Twilio: https://www.twilio.com/docs/voice/twiml/say/text-speech */
export const AUTOMATED_VOICE_AMAZON_VOICES = [
    {
        id: 'Polly.Ivy',
        label: 'Amazon Ivy · English (US) · Female',
        locale: 'en-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/ivy.70016451b3c186bcacba09acf5ee1b68c12db745.mp3',
    },
    {
        id: 'Polly.Joanna',
        label: 'Amazon Joanna · English (US) · Female',
        locale: 'en-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/joanna.84722a684fbb16e766944ea6e34dd0042195571c.mp3',
    },
    {
        id: 'Polly.Joey',
        label: 'Amazon Joey · English (US) · Male',
        locale: 'en-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/joey.3abd7f17e6dae6c9248cacd7eb0ec910c691c4f4.mp3',
    },
    {
        id: 'Polly.Justin',
        label: 'Amazon Justin · English (US) · Male',
        locale: 'en-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/justin.acfadcd365d37a1ecc88fdb2a640f1a75f83bdf7.mp3',
    },
    {
        id: 'Polly.Kendra',
        label: 'Amazon Kendra · English (US) · Female',
        locale: 'en-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/kendra.d768f43e12c08892d4495511e84e82f1b7195673.mp3',
    },
    {
        id: 'Polly.Kevin',
        label: 'Amazon Kevin · English (US) · Male (child)',
        locale: 'en-US',
        sampleUrl: undefined,
    },
    {
        id: 'Polly.Kimberly',
        label: 'Amazon Kimberly · English (US) · Female',
        locale: 'en-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/kimberly.42e50dd5056c92a5fff41952d0c057a7f09adca3.mp3',
    },
    {
        id: 'Polly.Matthew',
        label: 'Amazon Matthew · English (US) · Male',
        locale: 'en-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/matthew.b2a8b7d5b329742fc718c7a8d0efdad1c11fb25f.mp3',
    },
    {
        id: 'Polly.Salli',
        label: 'Amazon Salli · English (US) · Female',
        locale: 'en-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/salli.20a721cb6b8a5fbb016ab6d9ded37f9a91fe7a58.mp3',
    },
    {
        id: 'Polly.Lupe',
        label: 'Amazon Lupe · Spanish (US) · Female',
        locale: 'es-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/Lupe%20(Standard).85d69fc3a36ee08455b352221435154afd19420c.mp3',
    },
    {
        id: 'Polly.Miguel',
        label: 'Amazon Miguel · Spanish (US) · Male',
        locale: 'es-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/miguel.91030339cc81f8df461e3ab7325168fa5fdc0035.mp3',
    },
    {
        id: 'Polly.Penelope',
        label: 'Amazon Penelope · Spanish (US) · Female',
        locale: 'es-US',
        sampleUrl: 'https://d1.awsstatic.com/product-marketing/Polly/voices/penelope.7723493fdb9c6b7e1400efe02a5c1e7848310ba4.mp3',
    },
];
//# sourceMappingURL=amazonVoices.js.map